import fetch from 'isomorphic-fetch';
import {commonHeaders, commonErrorHandler} from './fetch.util';

export const MY_TOURNAMENT_PRINT_KIT_REQUEST = 'MY_TOURNAMENT_PRINT_KIT_REQUEST';
export const MY_TOURNAMENT_PRINT_KIT_RESPONSE_SUCCESS = 'MY_TOURNAMENT_PRINT_KIT_RESPONSE_SUCCESS';

export function myTournamentPrintKitRequest() {
  return {
    type: MY_TOURNAMENT_PRINT_KIT_REQUEST,
  };
}

export function myTournamentPrintKitResponseSuccess(tournamentPrintKitRequest) {
  return {
    type: MY_TOURNAMENT_PRINT_KIT_RESPONSE_SUCCESS,
    tournamentPrintKitRequest,
  };
}

export function fetchTournamentPrintKitRequestPost(tournamentPrintKitRequest, history) {
  return () => {
    fetch(`${API_URL}/tournament-print-kit-requests`, {
      method: 'POST',
      headers: commonHeaders(),
      body: JSON.stringify(tournamentPrintKitRequest),
    })
      .then(response => commonErrorHandler(response))
      .then(response => {
        if (response.status === 204) {
          alert('신청이 완료되었습니다.');
          history.push('/news/tournament-kit');
          return;
        }
        throw new Error('TournamentPrintKitRequest ERROR');
      });
  };
}

export function fetchMyTournamentPrintKitRequest() {
  return dispatch => {
    fetch(`${API_URL}/tournament-print-kit-requests/my-request`, {
      method: 'GET',
      headers: commonHeaders(),
    })
      .then(response => commonErrorHandler(response))
      .then(response => response.json())
      .then(json => {
        dispatch(myTournamentPrintKitResponseSuccess(json));
      });
  };
}
